var map = {
	"./Day.svg": 23166,
	"./Half-Night1.svg": 99615,
	"./Half-Night2.svg": 92112,
	"./Half-day1.svg": 53054,
	"./Half-day2.svg": 1985,
	"./Night.svg": 11041,
	"./add-skill-upload-icon.svg": 33674,
	"./addFavoriteSkills.svg": 79943,
	"./app-store.svg": 97179,
	"./archive-fill.svg": 595,
	"./area.svg": 13111,
	"./arrow-back.svg": 65285,
	"./arrow-down.svg": 34127,
	"./arrow-left-big.svg": 5535,
	"./arrow-up-big.svg": 81993,
	"./arrow-up-disabled.svg": 98028,
	"./arrow.svg": 95719,
	"./calendar.svg": 70782,
	"./cancel.svg": 16770,
	"./cancellation-day.svg": 73040,
	"./cancellation-night.svg": 6693,
	"./cancellationReports/cancellationRate.svg": 95419,
	"./cancellationReports/cancellationShifts.svg": 83783,
	"./cancellationReports/day.svg": 30624,
	"./cancellationReports/night.svg": 72598,
	"./cancellationReports/shiftPosted.svg": 44217,
	"./cancellationReports/solar_double-alt-arrow-down-bold-duotone.svg": 96922,
	"./cancellationReports/solar_double-alt-arrow-up-bold-duotone.svg": 50832,
	"./caret-down.svg": 67645,
	"./close.svg": 35860,
	"./completedSkill.svg": 11826,
	"./contactNurse.svg": 55900,
	"./contactNurseInactive.svg": 46192,
	"./created.svg": 40090,
	"./delete.svg": 64217,
	"./direct-history.svg": 11473,
	"./direct.svg": 31670,
	"./distant-history.svg": 53926,
	"./distant.svg": 88966,
	"./edit-skill-upload-icon.svg": 55248,
	"./endorsement-icon.svg": 17294,
	"./errorMessage.svg": 88401,
	"./expand-down.svg": 9960,
	"./expand-up.svg": 4074,
	"./expandMetrics.svg": 89639,
	"./export.svg": 45625,
	"./facebook.svg": 41693,
	"./file.svg": 90346,
	"./google-play-badge.svg": 19385,
	"./horizontalMenu/align-left.svg": 49407,
	"./horizontalMenu/award.svg": 16936,
	"./horizontalMenu/bar-chart-2.svg": 39196,
	"./horizontalMenu/bell.svg": 17862,
	"./horizontalMenu/columns.svg": 11411,
	"./horizontalMenu/cpu.svg": 92742,
	"./horizontalMenu/credit-card.svg": 33928,
	"./horizontalMenu/dollar-sign.svg": 57616,
	"./horizontalMenu/file.svg": 5252,
	"./horizontalMenu/folder.svg": 75790,
	"./horizontalMenu/framer.svg": 95806,
	"./horizontalMenu/gift.svg": 930,
	"./horizontalMenu/grid.svg": 20506,
	"./horizontalMenu/heart.svg": 4399,
	"./horizontalMenu/list.svg": 39839,
	"./horizontalMenu/package.svg": 77981,
	"./horizontalMenu/pie-chart.svg": 45141,
	"./horizontalMenu/plus.svg": 55384,
	"./horizontalMenu/pocket.svg": 44852,
	"./horizontalMenu/rotate-ccw.svg": 34889,
	"./horizontalMenu/search.svg": 36580,
	"./horizontalMenu/server.svg": 86851,
	"./horizontalMenu/settings.svg": 54583,
	"./horizontalMenu/sliders.svg": 48326,
	"./horizontalMenu/star.svg": 82923,
	"./horizontalMenu/tablet.svg": 77020,
	"./horizontalMenu/thumbs-up.svg": 29964,
	"./horizontalMenu/tool.svg": 6595,
	"./horizontalMenu/triangle.svg": 63214,
	"./horizontalMenu/user-plus.svg": 42043,
	"./horizontalMenu/user.svg": 73951,
	"./icon-approve-disabled.svg": 92787,
	"./icon-approve.svg": 15187,
	"./icon-reject-disabled.svg": 34826,
	"./icon-reject.svg": 47047,
	"./info.svg": 13759,
	"./infoIcon.svg": 6843,
	"./invite.svg": 73659,
	"./jobAppActive.svg": 71158,
	"./jobAppUnactive.svg": 18243,
	"./jobRatesActive.svg": 34607,
	"./jobRatesUnactive.svg": 61764,
	"./jobsTable.svg": 38467,
	"./jobsTableActive.svg": 75908,
	"./link2Icon.svg": 85926,
	"./linkedin.svg": 64296,
	"./logo.svg": 69574,
	"./magnifer.svg": 54117,
	"./mail.svg": 22059,
	"./managerReports/activeCandidate.svg": 60255,
	"./managerReports/back.svg": 80426,
	"./managerReports/badge.svg": 90676,
	"./managerReports/dayShifts.svg": 13800,
	"./managerReports/eye.svg": 20394,
	"./managerReports/gapShiftPosted.svg": 74892,
	"./managerReports/inactiveStaff.svg": 53441,
	"./managerReports/menu.svg": 62754,
	"./managerReports/nightShifts.svg": 60872,
	"./managerReports/otherCarelocation.svg": 61083,
	"./managerReports/reportProgress.svg": 90198,
	"./managerReports/shiftFillRate.svg": 52130,
	"./managerReports/shiftFilled.svg": 55181,
	"./managerReports/shiftPosted.svg": 20651,
	"./managerReports/skillGap.svg": 48654,
	"./managerReports/solar_double-alt-arrow-down-bold-duotone.svg": 86346,
	"./managerReports/solar_double-alt-arrow-up-bold-duotone.svg": 38603,
	"./managerReports/totalShifts.svg": 83644,
	"./managerReports/totalStaff.svg": 4474,
	"./managerReports/unfilledShifts.svg": 32101,
	"./managerReports/urCarelocation.svg": 54327,
	"./managerReports/vueDetailedReport.svg": 51224,
	"./managerSwapIcons/repeatIcon.svg": 75666,
	"./map-warning.svg": 36299,
	"./menu.svg": 63898,
	"./message-icon.svg": 58135,
	"./multi-profile-icon.svg": 83608,
	"./new.svg": 99397,
	"./no-comments.svg": 56920,
	"./ok.svg": 5753,
	"./paperclip.svg": 67173,
	"./pending.svg": 47062,
	"./profile/mail.svg": 47070,
	"./profile/phone.svg": 64643,
	"./profile/star-fill.svg": 30700,
	"./profile/star.svg": 25878,
	"./rates-logs/cancel.svg": 17574,
	"./rates-logs/check.svg": 57594,
	"./rates-logs/increase.svg": 86843,
	"./rates-logs/reject.svg": 89060,
	"./rates-logs/riskChange.svg": 41232,
	"./ratesTable.svg": 89563,
	"./ratesTableActive.svg": 52964,
	"./redeploymentIcon.svg": 2739,
	"./rejectedSkill.svg": 15408,
	"./remove-icon.svg": 50163,
	"./remove-skill.svg": 53494,
	"./removeFavoriteSkills.svg": 24006,
	"./search.svg": 51238,
	"./send.svg": 24492,
	"./sendIcon.svg": 75539,
	"./sign-out-icon.svg": 82519,
	"./skills.svg": 67834,
	"./skills/addSkillTree.svg": 10001,
	"./skills/editSkillTree.svg": 49833,
	"./skills/exportBtn.svg": 86465,
	"./skills/relationSkillTree.svg": 5719,
	"./skills/rolelistSkillTree.svg": 54659,
	"./skills/search.svg": 49464,
	"./skills/skills-multi.svg": 24113,
	"./slashIcon.svg": 28048,
	"./solo-history.svg": 80404,
	"./solo.svg": 7436,
	"./starIcon.svg": 14623,
	"./substantive-user.svg": 39134,
	"./success.svg": 18371,
	"./sync-bankshift.svg": 1855,
	"./sync-optima.svg": 34635,
	"./sync.svg": 43267,
	"./theme/fonts/feather/feather-webfont.svg": 45974,
	"./theme/fonts/fonts/fontawesome-webfont.svg": 73001,
	"./theme/fonts/fonts/glyphicons-halflings-regular.svg": 211,
	"./theme/fonts/fonts/revicons.svg": 62193,
	"./three-dots.svg": 25547,
	"./time-track/check.svg": 32430,
	"./time-track/close.svg": 80361,
	"./time-track/comment.svg": 50386,
	"./time-track/edit.svg": 2735,
	"./time-track/skills-approved.svg": 46242,
	"./time-track/skills.svg": 80570,
	"./time-track/time-separator.svg": 58782,
	"./trash.svg": 79916,
	"./twitter.svg": 56179,
	"./youtube.svg": 1242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40968;